import { Card } from '@deckee/deck-hand';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ROUTE_MAP } from '../../../services/route/route-names';
import { transitionToNextRoute } from '../../../services/route/route-navigation';
import { closePopover } from '../../../services/store/modules/app-controls';
import SheetLayout from '../../layouts/SheetLayout/SheetLayout';

const ConnectedPopover = () => {
  const showingPopOver = useSelector(
    (state) => state.appControls.showingPopOver,
  );
  const popOverConfig = useSelector((state) => state.appControls.popOverConfig);
  const popOverHeading = useSelector(
    (state) => state.appControls.popOverHeading,
  );

  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    dispatch(closePopover());
    transitionToNextRoute(ROUTE_MAP);
  }, [dispatch]);

  return (
    showingPopOver &&
    popOverConfig && (
      <SheetLayout
        heading={popOverHeading}
        showMenuBar={false}
        headingPosition="left"
        onClose={handleClose}
        popover
      >
        <Card bg="transparent">
          <Card.Body pt="0" pb="2">
            {popOverConfig}
          </Card.Body>
        </Card>
      </SheetLayout>
    )
  );
};

export default ConnectedPopover;
